import { WbsItemType } from '../../../domain/entity/WbsItemEntity'
import { ProjectPlanCumulation } from '../../../lib/functions/projectPlan'
import { WbsItemRow } from '../../../lib/functions/wbsItem'
import { CommentSummary } from '../../../store/comments'
import { AttachmentSummary } from '../../../utils/attachment'
import { ListRow } from '../../containers/BulkSheetView/model'

// 検索条件 rootUuids として指定可能な WBS タイプ（工程・成果物一覧・ワークグループ）
export const ROOT_WBS_ITEM_TYPES: WbsItemType[] = [
  WbsItemType.WORKGROUP,
  WbsItemType.PROCESS,
  WbsItemType.DELIVERABLE_LIST,
]

// 「成果物を含める」モードON時に使用する拡張版。成果物単体を工程スコープの
// 選択肢に含める際に使う（デフォルトの ROOT_WBS_ITEM_TYPES はパフォーマンスの
// ため変更しない）
export const ROOT_WBS_ITEM_TYPES_WITH_DELIVERABLE: WbsItemType[] = [
  ...ROOT_WBS_ITEM_TYPES,
  WbsItemType.DELIVERABLE,
]

export const MULTI_PROPERTY_DELIMITER: string = ','

// rootUuids を残すかどうかの判定で絞り込む。空になったら「条件なし」を表す undefined にする
export const pruneRootUuids = (
  rootUuids: string[] | undefined,
  shouldKeep: (uuid: string) => boolean
): string[] | undefined => {
  const pruned = (rootUuids ?? []).filter(shouldKeep)
  return pruned.length > 0 ? pruned : undefined
}

export interface WbsItemSearchRow extends ListRow {
  wbsItem: WbsItemRow
  path?: string
  projectPlanPathStale?: boolean
  cumulation?: ProjectPlanCumulation
  commentSummary?: CommentSummary
  deliverableAttachmentSummary?: AttachmentSummary
  typeIndex?: number
  ticketTypeIndex?: number
  parentWbsItem?: Partial<WbsItemRow>
}

export enum QuickFilterKeys {
  ACCOUNTABLE = 'ACCOUNTABLE',
  RESPONSIBLE_OR_ASSIGNEE = 'RESPONSIBLE_OR_ASSIGNEE',
}

export const WBS_ITEM_SEARCH_COUNT_LIMIT = 10000
